import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Mask Phone
import 'cleave.js/dist/addons/cleave-phone.br';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import { configureStore } from './store';
import { OfficeProvider } from './hook/useOffice';
import { loadAnimation } from 'lottie-web';
import { defineLordIconElement } from 'lord-icon-element';
import 'cleave.js/dist/addons/cleave-phone.br';
import { LoadingProvider } from './hook/useLoading';
import { PathnameProvider } from './hook/usePathname';
// register lottie and define custom element
defineLordIconElement(loadAnimation);

ReactDOM.render(
  <LoadingProvider>
    <Provider store={configureStore({})}>
      <React.Fragment>
        <OfficeProvider>
          <BrowserRouter>
            <PathnameProvider>
              <App />
            </PathnameProvider>
          </BrowserRouter>
        </OfficeProvider>
      </React.Fragment>
    </Provider>
  </LoadingProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
